<div class="page-title-area">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="page-title-text">
                    <h2>MISSIONS</h2>
                    <ul>
                        <li><a routerLink="/">ACCUEIL</a></li>
                        <li><i class="icofont-simple-right"></i></li>
                        <li>MISSIONS</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Missions Overview -->
<section class="missions-overview-section pt-100 pb-170">
    <div class="container">
        <div class="section-header">
            <div class="section-badge">
                <i class="icofont-star"></i>
                <span>Nos Objectifs</span>
            </div>
            <h2 class="section-title">Les Missions de la BSTP</h2>
            <p class="section-subtitle">
                La BSTP s'engage à promouvoir le développement économique de la Guinée à travers des partenariats stratégiques et la sous-traitance
            </p>
        </div>
        
        <div class="missions-grid">
            <div class="mission-card">
                <div class="card-header">
                    <div class="mission-icon">
                        <i class="icofont-handshake-deal"></i>
                    </div>
                    <div class="mission-number">01</div>
                </div>
                <div class="card-content">
                    <h3 class="mission-title">Faciliter les Partenariats</h3>
                    <p class="mission-description">
                        Créer des opportunités de partenariats entre entreprises locales et internationales pour stimuler l'investissement et le transfert de technologies.
                    </p>
                    <div class="mission-features">
                        <div class="feature-item">
                            <i class="icofont-check-circled"></i>
                            <span>Mise en relation B2B</span>
                        </div>
                        <div class="feature-item">
                            <i class="icofont-check-circled"></i>
                            <span>Accompagnement stratégique</span>
                        </div>
                        <div class="feature-item">
                            <i class="icofont-check-circled"></i>
                            <span>Transfert de compétences</span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="mission-card">
                <div class="card-header">
                    <div class="mission-icon">
                        <i class="icofont-company"></i>
                    </div>
                    <div class="mission-number">02</div>
                </div>
                <div class="card-content">
                    <h3 class="mission-title">Promouvoir la Sous-traitance</h3>
                    <p class="mission-description">
                        Développer l'écosystème de sous-traitance pour renforcer les capacités des PME/PMI guinéennes et créer de l'emploi local.
                    </p>
                    <div class="mission-features">
                        <div class="feature-item">
                            <i class="icofont-check-circled"></i>
                            <span>Formation des PME</span>
                        </div>
                        <div class="feature-item">
                            <i class="icofont-check-circled"></i>
                            <span>Certification qualité</span>
                        </div>
                        <div class="feature-item">
                            <i class="icofont-check-circled"></i>
                            <span>Accès aux marchés</span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="mission-card">
                <div class="card-header">
                    <div class="mission-icon">
                        <i class="icofont-chart-growth"></i>
                    </div>
                    <div class="mission-number">03</div>
                </div>
                <div class="card-content">
                    <h3 class="mission-title">Stimuler l'Innovation</h3>
                    <p class="mission-description">
                        Encourager l'innovation technologique et l'adoption de nouvelles pratiques pour améliorer la compétitivité des entreprises.
                    </p>
                    <div class="mission-features">
                        <div class="feature-item">
                            <i class="icofont-check-circled"></i>
                            <span>Technologies émergentes</span>
                        </div>
                        <div class="feature-item">
                            <i class="icofont-check-circled"></i>
                            <span>Innovation sociale</span>
                        </div>
                        <div class="feature-item">
                            <i class="icofont-check-circled"></i>
                            <span>Économie circulaire</span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="mission-card">
                <div class="card-header">
                    <div class="mission-icon">
                        <i class="icofont-globe"></i>
                    </div>
                    <div class="mission-number">04</div>
                </div>
                <div class="card-content">
                    <h3 class="mission-title">Développer l'Export</h3>
                    <p class="mission-description">
                        Faciliter l'accès aux marchés internationaux pour les entreprises guinéennes et promouvoir les exportations.
                    </p>
                    <div class="mission-features">
                        <div class="feature-item">
                            <i class="icofont-check-circled"></i>
                            <span>Marchés internationaux</span>
                        </div>
                        <div class="feature-item">
                            <i class="icofont-check-circled"></i>
                            <span>Accompagnement export</span>
                        </div>
                        <div class="feature-item">
                            <i class="icofont-check-circled"></i>
                            <span>Réseaux commerciaux</span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="mission-card">
                <div class="card-header">
                    <div class="mission-icon">
                        <i class="icofont-users-alt-4"></i>
                    </div>
                    <div class="mission-number">05</div>
                </div>
                <div class="card-content">
                    <h3 class="mission-title">Créer de l'Emploi</h3>
                    <p class="mission-description">
                        Contribuer à la création d'emplois durables et de qualité pour les jeunes et les populations locales.
                    </p>
                    <div class="mission-features">
                        <div class="feature-item">
                            <i class="icofont-check-circled"></i>
                            <span>Formation professionnelle</span>
                        </div>
                        <div class="feature-item">
                            <i class="icofont-check-circled"></i>
                            <span>Insertion professionnelle</span>
                        </div>
                        <div class="feature-item">
                            <i class="icofont-check-circled"></i>
                            <span>Développement local</span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="mission-card">
                <div class="card-header">
                    <div class="mission-icon">
                        <i class="icofont-settings"></i>
                    </div>
                    <div class="mission-number">06</div>
                </div>
                <div class="card-content">
                    <h3 class="mission-title">Moderniser l'Infrastructure</h3>
                    <p class="mission-description">
                        Soutenir le développement d'infrastructures modernes et durables pour faciliter les échanges commerciaux.
                    </p>
                    <div class="mission-features">
                        <div class="feature-item">
                            <i class="icofont-check-circled"></i>
                            <span>Infrastructures logistiques</span>
                        </div>
                        <div class="feature-item">
                            <i class="icofont-check-circled"></i>
                            <span>Connectivité numérique</span>
                        </div>
                        <div class="feature-item">
                            <i class="icofont-check-circled"></i>
                            <span>Énergies renouvelables</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- Impact Section -->
<section class="missions-impact-section">
    <div class="container">
        <div class="impact-content">
            <div class="impact-header">
                <h2 class="impact-title text-white">Impact de Nos Missions</h2>
                <p class="impact-subtitle">
                    Découvrez les résultats concrets de nos actions sur le développement économique de la Guinée
                </p>
            </div>
            
            <div class="impact-stats">
                <div class="stat-item">
                    <div class="stat-icon">
                        <i class="icofont-building"></i>
                    </div>
                    <div class="stat-number" data-target="3000">0</div>
                    <div class="stat-label">Entreprises Accompagnées</div>
                </div>
                
                <div class="stat-item">
                    <div class="stat-icon">
                        <i class="icofont-handshake-deal"></i>
                    </div>
                    <div class="stat-number" data-target="5000">0</div>
                    <div class="stat-label">Partenariats Créés</div>
                </div>
                
                <div class="stat-item">
                    <div class="stat-icon">
                        <i class="icofont-users-alt-4"></i>
                    </div>
                    <div class="stat-number" data-target="2000">0</div>
                    <div class="stat-label">Emplois Créés</div>
                </div>
                
                <div class="stat-item">
                    <div class="stat-icon">
                        <i class="icofont-chart-growth"></i>
                    </div>
                    <div class="stat-number" data-target="50">0</div>
                    <div class="stat-label">% de Croissance</div>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- Values Section -->
<section class="missions-values-section">
    <div class="container">
        <div class="section-header">
            <h2 class="section-title">Nos Valeurs</h2>
            <p class="section-subtitle">
                Les principes qui guident toutes nos actions et décisions
            </p>
        </div>
        
        <div class="values-grid">
            <div class="value-card">
                <div class="value-icon">
                    <i class="icofont-shield"></i>
                </div>
                <h3 class="value-title">Transparence</h3>
                <p class="value-description">
                    Nous agissons avec transparence et intégrité dans toutes nos relations et transactions.
                </p>
            </div>
            
            <div class="value-card">
                <div class="value-icon">
                    <i class="icofont-thumbs-up"></i>
                </div>
                <h3 class="value-title">Excellence</h3>
                <p class="value-description">
                    Nous visons l'excellence dans tous nos services et accompagnements.
                </p>
            </div>
            
            <div class="value-card">
                <div class="value-icon">
                    <i class="icofont-users-alt-4"></i>
                </div>
                <h3 class="value-title">Inclusion</h3>
                <p class="value-description">
                    Nous promouvons l'inclusion et l'égalité des chances pour tous.
                </p>
            </div>
            
            <div class="value-card">
                <div class="value-icon">
                    <i class="icofont-leaf"></i>
                </div>
                <h3 class="value-title">Durabilité</h3>
                <p class="value-description">
                    Nous privilégions des solutions durables et respectueuses de l'environnement.
                </p>
            </div>
        </div>
    </div>
</section>

<!-- CTA Section -->
<section class="missions-cta-section">
    <div class="container">
        <div class="cta-content">
            <div class="cta-icon">
                <i class="icofont-rocket"></i>
            </div>
            <h2 class="cta-title">Rejoignez la BSTP</h2>
            <p class="cta-subtitle">
                Découvrez comment nous pouvons vous accompagner dans vos projets de développement
            </p>
            <div class="cta-actions">
                <a routerLink="/contact" class="btn btn-primary">
                    <i class="icofont-phone"></i>
                    <span>Nous Contacter</span>
                </a>
                <a routerLink="/about" class="btn btn-outline-primary">
                    <i class="icofont-info-circle"></i>
                    <span>En Savoir Plus</span>
                </a>
            </div>
        </div>
    </div>
</section>